import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useYesNoLabel = () => {
  const { t } = useTranslation("common");
  const getLabel = useCallback((yes: boolean) => (yes ? t("labels.yes") : t("labels.no")), [t]);

  return getLabel;
};
